import '../../App.css';
import '../../css/GeneralActivity.css'
import '../../css/BlueActivities.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate} from 'react-router-dom';
import {useContext, useEffect, useState} from 'react';
import Instructions from '../../baseElements/Instructions'
import TopBar from '../../baseElements/TopBar';
import ConfirmButton from "../../baseElements/ConfirmButton";
import {activity_palettes} from '../../themes';
import axios from 'axios';
import SadFeedback from "../../baseElements/SadFeedback";
import HappyFeedback from "../../baseElements/HappyFeedback";
import AnimationOverlay from "../../baseElements/AnimationOverlay";
import patternBlueArrow from "../../assets/exercises/patternBlueArrow.svg";
import patternWhiteArrow from "../../assets/exercises/patternWhiteArrow.svg";
import {checkActivityStatus, delay, generateUrl, getExerciseFromDB, getLog, redirectToExercise, updateCurrentLog} from "../../ActivityManager";
import {AppContext} from "../../AppContext";
import NextExerciseButton from "../../baseElements/NextExerciseButton";
import NextQuestionButton from "../../baseElements/NextQuestionButton";
import Spinner from "react-bootstrap/Spinner";

axios.defaults.withCredentials = true;
const BACKGROUND_STYLE = activity_palettes.blue.secondary;
const INSTRUCTION_TEXT = "Prova a trovare la parola mancante seguendo l’esempio. Scrivila nel riquadro.";

function PatternMorph() {
    
    const {activityList, setActivityList, currentActivity} = useContext(AppContext);
    
    const navigate = useNavigate();
    
    const [words, setWords] = useState([]);
    const [wordsExample, setWordsExample] = useState([]);
    const [maxSteps, setMaxSteps] = useState(0);
    const [stepInfo, setStepInfo] = useState(1);
    const [levelInfo, setLevelInfo] = useState(0);
    const [instructionAudioUrl, setInstructionAudioUrl] = useState('');
    const [loading, setLoading] = useState(true);
    
    const [currentWordId, setCurrentWordId] = useState(0);
    const [writtenWord, setWrittenWord] = useState('');
    const [answered, setAnswered] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [wordColor, setWordColor] = useState('white');
    const [wordBackground, setWordBackground] = useState('#3851C4');
    const [isAnimating, setIsAnimating] = useState(false);
    const [flowButtons, setFlowButtons] = useState({confirm: true, nextExercise: false, nextQuestion: false});
    const [exerciseLog, setExerciseLog] = useState({exercise_id: 0, exercise_type: '', progress: 0, actions: []});
    
    const exerciseId = activityList[0][0];
    const exerciseType = activityList[0][1];
    
    function updateButtonFlow(showConfirm, ShowNextExercise, showNextWord) {
        setFlowButtons({confirm: showConfirm, nextExercise: ShowNextExercise, nextQuestion: showNextWord});
    }
    
    function resetStates() {
        setWords([]);
        setWordsExample([]);
        setMaxSteps(0);
        setStepInfo(1);
        setCurrentWordId(0);
        setWrittenWord('');
        setAnswered(false);
        setFeedback('');
        setWordColor('white');
        setWordBackground('#3851C4');
        setIsAnimating(false);
        setLoading(true);
        updateButtonFlow(true, false, false);
    }
    
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        
        window.onpopstate = (event) => {
            event.preventDefault();
            navigate('/home'); // Navigate directly to /home
        };
        
        return () => {
            window.onpopstate = null;
        };
    }, [navigate]);
    
    useEffect(() => {
        resetStates();
        loadExercise().then(
            () => {
                syncExerciseWithDB().then(() => setLoading(false));
            }
        );
    }, [navigate]);
    
    async function loadExercise() {
        await delay(750);
        getExerciseFromDB(activityList)
            .then((response) => {
                if (response.success) {
                    const json = JSON.parse(JSON.stringify(response.data[4]));
                    const level = JSON.parse(JSON.stringify(response.data[3]));
                    let temp1 = [];
                    let temp2 = [];
                    json.pattern.parts.forEach((activity) => {
                        temp1.push({id: activity.id, first: activity.first_word, second: activity.second_word});
                        temp2.push({id: activity.id, first: activity.first_word_example, second: activity.second_word_example});
                    });
                    
                    generateUrl("pattern").then((url) => {
                        setInstructionAudioUrl(url)
                    });
                    
                    setWords(temp1);
                    setWordsExample(temp2);
                    setMaxSteps(temp1.length);
                    setLevelInfo(level);
                } else {
                    console.log(response.errorMess);
                }
            })
            .catch((error) => {
                console.error('Error during loading exercise:', error);
            });
    }
    
    function syncExerciseWithDB() {
        return new Promise((resolve) => {
            getLog(currentActivity).then((response) => {
                if (response.success) {
                    const exercisesString = JSON.stringify(response.data);
                    const exercises = JSON.parse(exercisesString)[0];
                    if (exercises.some((exercise) => exercise.exercise_id === exerciseId)) {
                        const exercise = exercises.find((exercise) => exercise.exercise_id === exerciseId);
                        let partId = -1;
                        exercise.actions.forEach((action) => {
                            if (action.part_id > partId) {
                                partId = action.part_id;
                            }
                        });
                        partId++;
                        
                        setExerciseLog(exercise);
                        setCurrentWordId(partId);
                        setStepInfo(partId + 1);
                    }
                } else {
                    console.log(response.data.errorMess);
                }
                resolve();
            });
        });
    }
    
    function logUserAction(correct) {
        const progress = (currentWordId + 1) / words.length * 100;
        const timestamp = new Date().toISOString();
        const newAction = {
            part_id: currentWordId,
            startingWord: words[currentWordId].first,
            writtenWord: writtenWord,
            correct: correct,
            timestamp: timestamp,
        };
        
        setExerciseLog((prev) => ({
            ...prev,
            exercise_id: exerciseId,
            exercise_type: exerciseType,
            progress: Math.round(progress),
            actions: [...prev.actions, newAction],
        }));
    }
    
    function handleConfirmClick() {
        if(writtenWord.length === 0) {
            return;
        }
        setIsAnimating(true);
        setAnswered(true);
        console.log(writtenWord.toLowerCase());
        console.log(words[currentWordId].second)
        if (writtenWord.toLowerCase() === words[currentWordId].second) {
            logUserAction(true);
            setFeedback('happy');
            setWordColor(activity_palettes.green.secondary);
            setWordBackground(activity_palettes.green.tertiary);
        } else {
            logUserAction(false);
            setFeedback('sad');
            setWordColor(activity_palettes.green.error_text);
            setWordBackground(activity_palettes.green.error_background);
        }
        
        if (currentWordId < words.length - 1) {
            setTimeout(() => {
                updateButtonFlow(false, false, true);
                setIsAnimating(false);
            }, 1500);
            
        } else {
            setTimeout(() => {
                updateButtonFlow(false, true, false);
                setIsAnimating(false);
            }, 1500);
        }
    }
    
    function handleNextExerciseClick() {
        const temp = [...activityList];
        temp.shift();
        checkActivityStatus(currentActivity, temp).then(
            (response) => {
                try {
                    setActivityList(response);
                    redirectToExercise(response, navigate);
                } catch (error) {
                    console.log(error);
                }
            }
        );
    }
    
    function handleNextQuestionClick() {
        setStepInfo(stepInfo + 1);
        setCurrentWordId(currentWordId + 1);
        setAnswered(false);
        
        setFeedback('');
        setWordColor('white');
        setWordBackground('#3851C4');
        setWrittenWord('');
        updateButtonFlow(true, false, false);
    }
    
    const handleInputChange = (event) => {
        setWrittenWord(event.target.value);
    };
    
    useEffect(() => {
        if (exerciseLog.exercise_id !== 0) {
            updateCurrentLog(currentActivity, exerciseLog).then();
        }
    }, [exerciseLog]);
    
    if(loading) {
        return (
            <div className='generalActivitiesBackground custom-col-12 tablet-custom-col-12' style={{backgroundColor: BACKGROUND_STYLE}}>
                <Spinner animation="border" variant="light"/>
            </div>
        );
    }
    
    return (
        <div className='generalActivitiesBackground custom-col-12 tablet-custom-col-12' style={{backgroundColor: BACKGROUND_STYLE}}>
            <AnimationOverlay isAnimating={isAnimating}></AnimationOverlay>
            <div className='generalActivitiesPageContent custom-col-11 tablet-custom-col-11'>
                <div className={`generalActivitiesTopBarArea custom-row ${answered ? "disabledElement" : ""}`}>
                    <TopBar levelInfo={levelInfo} stepInfo={stepInfo} maxSteps={maxSteps}></TopBar>
                    <Instructions hasAudio={false} instructionText={INSTRUCTION_TEXT} instructionAudioUrl={instructionAudioUrl}></Instructions>
                </div>
                <div className={`generalActivitiesGameElementsArea row ${answered ? "disabledElement" : ""}`}>
                    <div className='generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2'>
                        <SadFeedback feedback={feedback.includes('sad')}></SadFeedback>
                    </div>
                    <div className='generalActivitiesColumnTwoColumnsLayout custom-col-4 tablet-custom-col-4'>
                        <div className='blueActivitiesExample'>
                            <div className='exampleInstruction'>Segui l'esempio!</div>
                            <div className='exampleBox'>
                                <div className='exampleFirstWord'>
                                    {wordsExample.length > 0 ? wordsExample[currentWordId].first : ''}
                                </div>
                                <div className='exampleArrow'>
                                    <img className="purpleActivitiesWordImage" src={patternBlueArrow} alt={'icon not found'}></img>
                                </div>
                                <div className='exampleSecondWord'>
                                    {wordsExample.length > 0 ? wordsExample[currentWordId].second : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='generalActivitiesColumnTwoColumnsLayout custom-col-4 tablet-custom-col-4 flex-column' style={{flexWrap: 'nowrap'}}>
                        <div className="blueActivitiesArea blueActivitiesTargetTextArea center"
                             style={{backgroundColor: 'white', width: '60%', fontSize: 'xx-large', borderRadius: '60px', height: '40%'}}>
                            {words.length > 0 ? words[currentWordId].first : ''}
                        </div>
                        <img className="purpleActivitiesWordImage" src={patternWhiteArrow} alt={'icon not found'}></img>
                        <div className='center blueActivitiesArea blueActivitiesEnabledInputTextArea' style={{backgroundColor: wordBackground}}>
                            <input className='textFastReadArea'
                                   value={writtenWord}
                                   onChange={handleInputChange}
                                   style={{color: wordColor}}
                            ></input>
                        </div>
                    </div>
                    <div className='generalActivitiesFeedbackArea custom-col-2 tablet-custom-col-2'>
                        <HappyFeedback feedback={feedback.includes('happy')}></HappyFeedback>
                    </div>
                </div>
                <div className='generalActivitiesConfirmButtonArea custom-row'>
                    {flowButtons.confirm && <ConfirmButton onClick={handleConfirmClick}/>}
                    {flowButtons.nextExercise && <NextExerciseButton onClick={handleNextExerciseClick}/>}
                    {flowButtons.nextQuestion && <NextQuestionButton onClick={handleNextQuestionClick}/>}
                </div>
            </div>
        </div>
    );
}

export default PatternMorph;
